import React from 'react';

import { ServiceContext } from './ServiceContext';
import { ServiceContextType } from './common.types';

export const useServiceContext = (): ServiceContextType =>
  React.useContext(ServiceContext);
